'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z' });

var FreeBreakfast = function FreeBreakfast(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

FreeBreakfast = (0, _pure2.default)(FreeBreakfast);
FreeBreakfast.muiName = 'SvgIcon';

exports.default = FreeBreakfast;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/FreeBreakfast.js
// module id = 2452
// module chunks = 0